import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProfile } from "../Components/Hooks/UserHooks";
import { setAuthorization } from "../helpers/api_helper";
import LoadingSpinner from "../Components/Common/LoadingSpinner";

const AuthProtected = ({ children }) => {
  const { userProfile, loading } = useProfile();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!userProfile || !userProfile.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Set authorization header for API calls
  setAuthorization(userProfile.token);

  // Render protected content
  return <>{children}</>;
};

export default AuthProtected;
